import React, { useState, useEffect,} from "react";
import { Col, Modal, Nav, Row, Tab, Image, Button, InputGroup, Form } from "react-bootstrap";
import Card from "../../../components/card/AdminCard";
import LearningModulesEdit from "./LearningModulesEdit";
import LearningModulesModal from "../modal/LearningModulesModal";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { GetAwarenessModule,selectAwarenessModule } from "../../../features/learning/AwarenessSlice";

import Edit from '../../../assets/images/ic-edit.svg';
import Add from '../../../assets/images/ic-add.svg';
import Back from '../../../assets/images/ic-arrow-back.svg';
import Search from "../../../assets/images/search-line.svg";
import Dots from "../../../assets/images/la-dots.svg";
import LearningModules from "../sections/LearningModules";
import SearchBar from "../../../components/searchbar/SearchBar";
import EmptyRow from "../../../components/emptyRow/EmptyRow";
import VideoItemAdmin from "../../../components/card/VideoItemAdmin";
import Feedback from "../../../components/feedbackNote/Feedback";

const title: String = "";
const title2: String = "Ethics Counsellor Learning Program";

const VideoModulesEditDetails = () => 
{
    const [modalShow, setModalShow] = useState(false);  
    const handleClose = () => setModalShow(false);
    const handleShow = () => setModalShow(true);
    const AwarenessModule = useAppSelector(selectAwarenessModule);
    const dispatch = useAppDispatch();
    const [ofset, setOfset]=useState(0);
    const userDetails = localStorage.getItem("userDetails");
    const userDetailsList: any = userDetails;
    const userDetailsJson = JSON.parse(userDetailsList);
    useEffect(() => {
      var data={
        keyword:"",
        offset:0,
        companyId:userDetailsJson.companyId
      }
      async function fetchAwarenessModuleData() {
        let sample = await dispatch(GetAwarenessModule(data));
      }
      fetchAwarenessModuleData();
    }, []);

    const [searchData, setsearchData]=useState('')
    const searchItems=async(searchValue:any)=>{
      await setsearchData(searchValue)
      var data={
        keyword:searchData,
        offset:0,
        companyId:userDetailsJson.companyId
      }
      
        await dispatch(GetAwarenessModule(data))
    }
  
  return (
    <>
    <Feedback pageName="Learning And Awarness"/>
    <Row>
      <Col sm={12}>
      <a href="/videomodulesDetails">
        <span style={styles.backstyle}><Image src={Back} />Back </span>
      </a>  
      </Col>
    </Row>
    <EmptyRow/>
   
    <Row>
        <Col sm={8}>
        <h4>Videos</h4>
        </Col>

        <Col sm={4}>
        <InputGroup className="border bg-white" style={{border: "solid 1px #e4e4e4",}}>
                <Image style={styles.image1} className="d-inline border-0 my-auto mx-2" src={Search} fluid />
                <Form.Control onChange={(e) => searchItems(e.target.value)} name={searchData} className="border-0 shadow-none ps-0" style={styles.text1} type="text" placeholder="Search" />
            </InputGroup>
        </Col>
    </Row>    

    <EmptyRow/>

    
      
    <div style={{ marginBottom: "20px" }}>     
                                <Row >
                                    {AwarenessModule.map((item: any) => (
                                    <VideoItemAdmin item={item} columns={3}/>  
                                    ))}
                                </Row>
     
      </div>

      
    </>
  );
};

const styles: any = {
    editstyle: {
        color: "#e31837",
        fontFamily: "Georama-Regular",
        fontWeight: 600,
        fontSize: "12px",
        float:"right",
        marginTop:"10px",
        
    },

    backstyle: {
      color: "#e31837",
      fontFamily: "Georama-Regular",
      fontWeight: 600,
      fontSize: "12px",
      marginTop:"10px",
      
  },
};

export default VideoModulesEditDetails
